import React from 'react';
import { Form } from '../../../ui/universe';
import { Radio, Tooltip } from 'tdesign-react';

/** 分组名称宽度，与表单 label 列宽保持一致 */
const DEFAULT_GROUP_LABEL_WIDTH = 140;

/**
 * 按 group 字段把选项分组，无 group 时视为单一分组
 */
function groupOptions(options = []) {
  if (!options.some((op) => op.group)) {
    return [{ name: '', options }];
  }
  const groups = [];
  options.forEach((op) => {
    const name = op.group || '';
    let group = groups.find((g) => g.name === name);
    if (!group) {
      group = { name, options: [] };
      groups.push(group);
    }
    group.options.push(op);
  });
  return groups;
}

const radioGroupStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  columnGap: '24px',
  rowGap: '8px',
};

/**
 * Radio 参数渲染器
 * 支持 options 按 group 分组展示（如「经营场所照」「车牌业务照」）
 */
function RadioRenderer({ params, value, disabled, onChange }) {
  const groups = groupOptions(params.options);
  const hasGroup = groups.some((group) => group.name);

  const handleChange = (val) => {
    const extra = params.options[params.options.findIndex((i) => i.value === val)];
    onChange && onChange(val, val, extra);
  };

  const renderRadioGroup = (group, key) => (
    <Radio.Group
      key={key}
      value={value}
      disabled={disabled}
      style={radioGroupStyle}
      onChange={handleChange}
      className="unv-radio__group"
    >
      {group.options.map((op, index) => (
        <Radio key={index} value={op.value} style={{ marginRight: 0 }}>
          <span>{op.text}</span>
          {op.des && (
            <Tooltip content={op.des} theme="light">
              <span className="ocrDemo-icon-question"></span>
            </Tooltip>
          )}
        </Radio>
      ))}
    </Radio.Group>
  );

  // 分组场景下不再单独显示 label（分组名已占用标签列位置）
  const labelNode = params.label ? (
    <>
      <span>{params.label}</span>
      {params.des && (
        <Tooltip content={params.des} theme="light">
          <span className="ocrDemo-icon-question"></span>
        </Tooltip>
      )}
    </>
  ) : undefined;

  return (
    <Form.Item
      className={`${params.LabelAlign ? 'column' : 'row'}`}
      label={labelNode}
    >
      {hasGroup ? (
        <div style={{ width: '100%' }}>
          {groups.map((group, groupIndex) => (
            <div
              key={group.name || groupIndex}
              style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}
            >
              {group.name && (
                <span
                  style={{
                    width: params.groupLabelWidth || DEFAULT_GROUP_LABEL_WIDTH,
                    flex: 'none',
                    color: '#010B3269'
                  }}
                >
                  {group.name}
                </span>
              )}
              {renderRadioGroup(group, group.name || groupIndex)}
            </div>
          ))}
        </div>
      ) : (
        renderRadioGroup(groups[0], 'default')
      )}
    </Form.Item>
  );
}

export default RadioRenderer;
